import { useQuery } from '@tanstack/react-query';
import { fetchEpoch, type EpochInfo } from '../lib/minerApi.js';

export function useEpoch() {
  return useQuery<EpochInfo>({
    queryKey: ['epoch'],
    queryFn: fetchEpoch,
    staleTime: 30_000,
    retry: 1,
  });
}
